import React, { useState } from "react";
import Navbar from "./navbar.jsx";
import Buscador from "./buscador.jsx";
import Sidebar from "./sidebar.jsx";

export default function HomePage() {
  const [actualizarProductos, setActualizarProductos] = useState(false);
  const [actualizarProveedor, setActualizarProveedor] = useState(false);

  return (
    <>
      <Navbar
        setActualizar={setActualizarProductos}
        setActualizarProveedor={setActualizarProveedor}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <h1 className="page-title">Solicitud de Productos</h1>
        <Buscador
          actualizar={actualizarProductos}
          setactualizar={setActualizarProductos}
          actualizarProveedor={actualizarProveedor}
          setActualizarProveedor={setActualizarProveedor}
        />
      </div>
      <Sidebar />
    </>
  );
}
